import { ShortcodeFn } from 'components/vendor/Contentful/richText/ShortcodeManager'
import { logBadThings, sanitizeUrl } from 'components/vendor/Contentful/richText/ShortcodeManager/utils'
import Link from 'next/link'
import React from 'react'

export const linkShortcode: ShortcodeFn = (name, attrs) => {
	const { link, text } = attrs
	logBadThings(link)
	const safeUrl = sanitizeUrl(link)
	const localLink = safeUrl.charAt(0) === '/'
	const target = localLink ? '_self' : '_blank'
	const rel = localLink ? '' : 'noreferrer nofollow noopener'
	return (
		<Link href={safeUrl} passHref style={{ textDecoration: 'unset' }} target={target} rel={rel}>
			{text}
		</Link>
	)
}
